import React from 'react'

const LoadingSpinner = ({ text, style }) => {
  return (
    <div className="k-i-loading" style={{ minWidth: '30px', minHeight: '30px' }}>
      {text}
    </div>
  )
}

export default LoadingSpinner
